// extracted by mini-css-extract-plugin
export default {"wrapper":"Actions_wrapper__CSbuw","button":"Actions_button__VaM5S"};